import apiSlice from "./apiSlice";
const monteCarloApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllMonteCarloSimulation: builder.query({
            query: (req) => ({
                url: `MonteCarloSimulation`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllMonteCarloSimulation"],
        }),
        addMonteCarloSimulation: builder.mutation({
            query: (body) => ({
                url: `MonteCarloSimulation`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['AllMonteCarloSimulation']
        }),
        publishMonteCarloSimulation: builder.mutation({
            query: ({ params, id }) => ({
                url: `MonteCarloSimulation/${id}`,
                method: 'PUT',
                params
            }),
            invalidatesTags: ['AllMonteCarloSimulation']
        }),
    }),
});

export const { useGetAllMonteCarloSimulationQuery, useAddMonteCarloSimulationMutation, usePublishMonteCarloSimulationMutation } = monteCarloApiSlice;
